import { authenticatedFastApiAxiosInstance } from "@/lib/data/http";
import { type APIResponse, type Firm } from "@/lib/types";

export const baseFastApiFirmRoute = "firms/v2";

export function updateFirmV1(
  data: Pick<Firm, "name" | "dateModified"> & Partial<Omit<Firm, "id">>,
) {
  return authenticatedFastApiAxiosInstance
    .patch<APIResponse<Firm>>(baseFastApiFirmRoute, data)
    .then((res) => res.data);
}

export function updateFirmProfilePictureV1(
  data: Pick<Firm, "dateModified" | "profilePicturePresignedUrlKey">,
) {
  return authenticatedFastApiAxiosInstance
    .patch<APIResponse<Firm>>(baseFastApiFirmRoute, data)
    .then((res) => res.data);
}
